<script lang="ts" setup>
  import {
    containerClass,
    firstItemClass,
    itemClass,
    lastItemClass,
  } from './SectionDetail.css';
  import type { SectionDetailItem } from './SectionDetail.types';

  const props = defineProps<{
    items: SectionDetailItem[];
  }>();

  const currentItemClass = (index: number) => {
    switch (index) {
      case 0:
        return firstItemClass;
      case props.items.length - 1:
        return lastItemClass;
      default:
        return itemClass;
    }
  };
</script>

<template>
  <div :class="containerClass">
    <span
      v-for="(item, index) in props.items"
      :key="item.value"
      :class="currentItemClass(index)"
    >
      {{ item.key }} <b>{{ item.value }}</b>
    </span>
    <slot name="actions" />
  </div>
</template>
